import type { ComponentProps } from 'react';
import { Alert } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

import { useAuth } from '@furality/frontend-stack';
import { Button } from '@furality/furality-purpose';
import ErrorDisplayBase from '#/components/ErrorDisplay.tsx';

export const PortalDefaultContent = () => (
  <>
    Please reach out to our{' '}
    <Alert.Link
      href="https://discord.com/channels/693598922064789635/711798995139166318"
      className="text-underline"
    >
      help channel
    </Alert.Link>{' '}
    for troubleshooting.
  </>
);

export const PortalLoginErrorContent = () => {
  const { t } = useTranslation();
  const auth = useAuth();

  return (
    <>
      <p>
        <Trans
          i18nKey="shared.login_error.content"
          components={{
            link: (
              <Alert.Link
                href="https://discord.com/channels/693598922064789635/711798995139166318"
                className="text-underline"
              />
            ),
          }}
          className="mb-2"
        />
      </p>
      <div className="text-center">
        <Button onClick={() => auth.login()} size="sm" className="text-center">
          {t('shared.login_button')}
        </Button>
      </div>
    </>
  );
};

const ErrorDisplay = ({ children, ...rest }: ComponentProps<typeof ErrorDisplayBase>) => (
  <ErrorDisplayBase {...rest}>{children ?? <PortalDefaultContent />}</ErrorDisplayBase>
);

export default ErrorDisplay;
